import { Location } from '@hakimo-ui/hakimo/types';
import clsx from 'clsx';

interface Props {
  location: Location;
}

export function MonitoringStatus(props: Props) {
  const { location } = props;

  if (!location.armStatus) {
    return null;
  }

  const { isArmed } = location.armStatus;

  return (
    <div className="flex flex-col items-center gap-1">
      <span className="text-onlight-text-2 dark:text-ondark-text-1 text-sm font-medium">
        Monitoring Status
      </span>
      <span
        className={clsx(
          'text-sm font-semibold',
          isArmed ? 'text-status-orange' : 'text-status-green'
        )}
      >
        {isArmed ? 'Armed' : 'Disarmed'}
      </span>
    </div>
  );
}

export default MonitoringStatus;
